// extracted by mini-css-extract-plugin
module.exports = {"swiper":"style_swiper__TS1N2","large":"style_large__vXqJH","default":"style_default__4XsEd"};